import moment from "moment";
import { RootState } from "store/store";

export const getLastInvoice = (state: RootState) => {
  const invoices = state.invoiceData.invoices;
  if (invoices && invoices.length) {
    const latestInvoice = (invoices || []).reduce((prev, curr) =>
      moment(prev.created) > moment(curr.created) ? prev : curr
    );
    return latestInvoice;
  }
  return null;
};

export const getRemainingGracePeriodDays = (gracePeriodDate: string) => {
  const currentDate = moment();
  return moment(gracePeriodDate, "YYYY-MM-DD").diff(currentDate, "days");
};
